import { Permission } from '@/common/enums/permissions';

export function getUserInitials(lastName, firstName, secondName) {
    if (lastName) {
        if (firstName) {
            if (secondName) {
                return `${lastName} ${firstName.substring(0, 1)}. ${secondName.substring(0, 1)}.`;
            }
            return `${lastName} ${firstName.substring(0, 1)}.`;
        } else {
            return lastName;
        }
    }
}
export function getUserFullName(lastName, firstName, secondName) {
    if (lastName) {
        if (firstName) {
            if (secondName) {
                return `${lastName} ${firstName} ${secondName}`;
            }
            return `${lastName} ${firstName}`;
        } else {
            return lastName;
        }
    }
}
export function userMapper(currentUser) {
    let user = {
        address: currentUser.Address,
        applications: currentUser.Applications,
        email: currentUser.Email,
        firstName: currentUser.FirstName,
        id: currentUser.ID,
        imagePath: currentUser.ImagePath,
        isNBRB: currentUser.IsNBRB,
        lastName: currentUser.LastName,
        login: currentUser.Login,
        mobileNumber: currentUser.MobileNumber,
        phoneNumber: currentUser.PhoneNumber,
        secondName: currentUser.SecondName,
        status: currentUser.Status,
        externalRoles: [],
        permissions: [],
        limited: currentUser.Limited,
    };
    if (currentUser.Permissions && currentUser.Permissions.length) {
        user.permissions = currentUser.Permissions.map(permission => {
            return {
                entityKey: permission.PermissionKey,
                mask: permission.Mask,
                titleObject: permission.Title,
                permissionView: (permission.Mask & (1 << Permission.View)) !== 0,
                permissionCreate: (permission.Mask & (1 << Permission.Create)) !== 0,
                permissionEdit: (permission.Mask & (1 << Permission.Edit)) !== 0,
                permissionDelete: (permission.Mask & (1 << Permission.Delete)) !== 0,
            };
        });
    }
    if (currentUser.ExternalRoles && currentUser.ExternalRoles.length) {     
        user.externalRoles = currentUser.ExternalRoles.map(roles => {
            return {
                id: roles.ID,
                title: roles.Title,
            };
        });
    }
    return user;
}


// WEBPACK FOOTER //
// ./common/helpers/user-helper.ts